export default "__VITE_ASSET__1d5d7d96__"